// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: transparent;
}

.page-title {
  padding-top: 0.333rem;
  text-align: center;
}
.page-title .label {
  color: var(--color-primary-blue);
  font-size: 1rem;
}

.tabs {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 0.3rem;
  margin-bottom: 1rem;
}
.tabs .tab {
  position: relative;
  border-radius: 8px;
  border: 2px solid rgba(0, 51, 153, 0.32);
  box-sizing: border-box;
  width: -moz-fit-content;
  width: fit-content;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  color: var(--color-primary-blue);
  cursor: pointer;
}
.tabs .tab:hover {
  border: 0;
  border-radius: 8px;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
}
.tabs .tab:hover:not(.active) {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, var(--color-white) 100%);
}
.tabs .tab .label {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  padding: 0.5rem 1.042rem;
}
.tabs .tab:not(.active):hover .label {
  padding: calc(0.5rem + 2px) calc(1.042rem + 2px);
}
.tabs .tab.active {
  font-weight: bold;
  border: 0;
  background-color: var(--color-light-blue);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
}
.tabs .tab.active .label {
  padding: calc(0.5rem + 2px) calc(1.042rem + 2px);
}
.tabs .tab.active:before {
  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, var(--color-white) 100%);
  content: "";
  display: block;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 8px;
  width: 100%;
  z-index: 1;
}
.tabs .tab.active:after {
  content: "";
  width: 1rem;
  height: 1rem;
  position: absolute;
  bottom: -0.458rem;
  left: calc(50% + 0.5rem);
  transform: translateX(-100%) rotateZ(45deg);
  z-index: 0;
  background: var(--color-light-blue);
  box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.16);
}
.tabs .tab:not(last-child) {
  margin-right: 1.25rem;
}

.badge {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.badge .icon {
  position: relative;
  max-width: 160px;
  width: 5.667rem;
}
.badge .icon .bg {
  width: auto;
  height: 100%;
}
.badge .icon .image {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: auto;
}
.badge .icon .image ::ng-deep svg {
  width: 100%;
  height: auto;
}
.badge .icon .info {
  position: absolute;
  top: 0;
  right: 0;
  width: 1.9rem;
  height: 1.9rem;
  margin-top: -0.5rem;
}
.badge .icon .info ::ng-deep svg {
  width: 2rem;
  height: auto;
}
.badge .icon .info .text {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-green);
  font-size: 1rem;
  font-weight: bold;
  letter-spacing: 0;
  text-align: center;
}
.badge .box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 2rem;
  background: rgba(0, 51, 153, 0.2);
  margin-top: -1.083rem;
  text-align: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.badge .box .title {
  color: var(--color-white);
  font-size: 1.1rem;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 1rem;
  text-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.24);
  padding-top: 1.292rem;
}
.badge .box .description {
  color: var(--color-primary-blue);
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1rem;
  padding-bottom: 0.542rem;
}
.badge.locked .box {
  background: none;
}

.scoreboard .text {
  color: var(--color-primary-blue);
  font-weight: 600;
  font-size: 0.9rem;
}
.scoreboard .text.score {
  font-size: 1rem;
}
.scoreboard .bold-text {
  color: var(--color-white);
  font-weight: 800;
  font-size: 1.121rem;
}
.scoreboard .bold-text.score {
  font-size: 1.569rem;
}
.scoreboard .score-row {
  border-radius: 8px;
  background: rgba(0, 51, 153, 0.16);
  margin-bottom: 0.333rem;
}
.scoreboard .score-col {
  padding-top: 0.533rem;
  padding-bottom: 0.533rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
.scoreboard .score-col .date {
  white-space: nowrap;
}
.scoreboard .score-col.badges {
  padding-right: 1rem;
  display: flex;
}
.scoreboard .score-col.badges .icon {
  position: relative;
  width: 1.333rem;
  height: 1.333rem;
}
.scoreboard .score-col.badges .icon:not(:last-child) {
  margin-right: 0.333rem;
}
.scoreboard .score-col.badges .icon .bg {
  width: auto;
  height: 100%;
}
.scoreboard .score-col.badges .icon .image {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: auto;
}
.scoreboard .score-col.score {
  background: rgba(0, 51, 153, 0.2);
  display: flex;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.scoreboard .score-col.country {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.scoreboard .score-col.country div:first-child {
  margin-bottom: -0.25rem;
}
.scoreboard .score-col.country .flag {
  height: 1.333rem;
  width: 1.333rem;
  box-shadow: 0 0.083rem 0 0 rgba(0, 0, 0, 0.24);
  border-radius: 1.333rem;
  margin-right: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/achievements/achievements.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;AACF;AACE;EACE,gCAAA;EACA,eAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAAF;AAEE;EACE,kBAAA;EACA,kBAAA;EACA,wCAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AAAJ;AAEI;EACE,SAAA;EACA,kBAAA;EACA,yCAAA;AAAN;AAEM;EACE,qFAAA;AAAR;AAII;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,wBAAA;AAFN;AAKI;EACE,gDAAA;AAHN;AAMI;EACE,iBAAA;EACA,SAAA;EACA,yCAAA;EACA,yCAAA;AAJN;AAKM;EACE,gDAAA;AAHR;AAMM;EACE,qFAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAJR;AAOM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,wBAAA;EACA,2CACE;EAEF,UAAA;EACA,mCAAA;EACA,2CAAA;AAPR;AAWI;EACE,qBAAA;AATN;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAXF;AAaE;EACE,kBAAA;EACA,gBAAA;EAEA,eAAA;AAZJ;AAcI;EACE,WAAA;EACA,YAAA;AAZN;AAeI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AAbN;AAeM;EACE,WAAA;EACA,YAAA;AAbR;AAiBI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AAfN;AAiBM;EACE,WAAA;EACA,YAAA;AAfR;AAkBM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAhBR;AAoBE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;AAlBJ;AAoBI;EACE,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,0CAAA;EACA,qBAAA;AAlBN;AAoBI;EACE,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAlBN;AAsBI;EACE,gBAAA;AApBN;;AA0BE;EACE,gCAAA;EACA,gBAAA;EACA,iBAAA;AAvBJ;AAyBI;EACE,eAAA;AAvBN;AA2BE;EACE,yBAAA;EACA,gBAAA;EACA,mBAAA;AAzBJ;AA2BI;EACE,mBAAA;AAzBN;AA6BE;EACE,kBAAA;EACA,kCAAA;EACA,uBAAA;AA3BJ;AA8BE;EACE,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;AA5BJ;AA8BI;EACE,mBAAA;AA5BN;AA+BI;EACE,mBAAA;EACA,aAAA;AA7BN;AA+BM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AA7BR;AA8BQ;EACE,sBAAA;AA5BV;AA+BQ;EACE,WAAA;EACA,YAAA;AA7BV;AAgCQ;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AA9BV;AAkCI;EACE,iCAAA;EACA,aAAA;EACA,4BAAA;EACA,+BAAA;AAhCN;AAkCI;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAhCN;AAkCM;EACE,uBAAA;AAhCR;AAmCM;EACE,gBAAA;EACA,eAAA;EACA,8CAAA;EACA,uBAAA;EACA,kBAAA;AAjCR","sourcesContent":["ion-content {\n  --background: transparent;\n}\n\n.page-title {\n  padding-top: 0.333rem;\n  text-align: center;\n\n  .label {\n    color: var(--color-primary-blue);\n    font-size: 1rem;\n  }\n}\n\n.tabs {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 0.3rem;\n  margin-bottom: 1rem;\n\n  .tab {\n    position: relative;\n    border-radius: 8px;\n    border: 2px solid rgba(0, 51, 153, .32);\n    box-sizing: border-box;\n    width: fit-content;\n    font-size: 1rem;\n    font-weight: 600;\n    text-align: center;\n    color: var(--color-primary-blue);\n    cursor: pointer;\n\n    &:hover {\n      border: 0;\n      border-radius: 8px;\n      box-shadow: 0 2px 0 0 rgba(0,0,0,0.16);\n\n      &:not(.active) {\n        background: linear-gradient(0deg, rgba(255,255,255,0) 0%, var(--color-white) 100%);\n      }\n    }\n\n    & .label {\n      position: relative;\n      width: 100%;\n      height: auto;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      z-index: 2;\n      padding: 0.5rem 1.042rem;\n    }\n\n    &:not(.active):hover .label {\n      padding: calc(0.5rem + 2px) calc(1.042rem + 2px);\n    }\n\n    &.active {\n      font-weight: bold;\n      border: 0;\n      background-color: var(--color-light-blue);\n      box-shadow: 0 2px 0 0 rgba(0,0,0,0.16);\n      & .label {\n        padding: calc(0.5rem + 2px) calc(1.042rem + 2px);\n      }\n\n      &:before {\n        background: linear-gradient(0deg, rgba(255,255,255,0) 0%, var(--color-white) 100%);\n        content: '';\n        display: block;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        border-radius: 8px;\n        width: 100%;\n        z-index: 1;\n      }\n\n      &:after {\n        content: '';\n        width: 1rem;\n        height: 1rem;\n        position: absolute;\n        bottom: -0.458rem;\n        left: calc(50% + 0.5rem);\n        transform:\n          translateX(-100%)\n          rotateZ(45deg);\n        z-index: 0;\n        background: var(--color-light-blue);\n        box-shadow: 2px 2px 0 0 rgba(0,0,0,0.16);\n      }\n    }\n\n    &:not(last-child) {\n      margin-right: 1.25rem;\n    }\n  }\n}\n\n.badge {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .icon {\n    position: relative;\n    max-width: 160px;\n    // max-height: 160px;\n    width: 5.667rem;\n\n    .bg {\n      width: auto;\n      height: 100%;\n    }\n\n    .image {\n      position: absolute;\n      top: 0;\n      left: 0;\n      display: flex;\n      width: 100%;\n      height: auto;\n\n      ::ng-deep svg {\n        width: 100%;\n        height: auto;\n      }\n    }\n\n    .info {\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 1.9rem;\n      height: 1.9rem;\n      margin-top: -0.5rem;\n\n      ::ng-deep svg {\n        width: 2rem;\n        height: auto;\n      }\n\n      .text {\n        position: absolute;\n        top: 0;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: var(--color-green);\n        font-size: 1rem;\n        font-weight: bold;\n        letter-spacing: 0;\n        text-align: center;\n      }\n    }\n  }\n  .box {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    border-radius: 2rem;\n    background:rgba(0, 51, 153, .20);\n    margin-top: -1.083rem;\n    text-align: center;\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n\n    .title {\n      color: var(--color-white);\n      font-size: 1.1rem;\n      font-weight: bold;\n      letter-spacing: 0;\n      line-height: 1rem;\n      text-shadow: 0 2px 0 0 rgba(0,0,0,0.24);\n      padding-top: 1.292rem;\n    }\n    .description {\n      color: var(--color-primary-blue);\n      font-size: 0.9rem;\n      font-weight: 600;\n      line-height: 1rem;\n      padding-bottom: 0.542rem;\n    }\n  }\n  &.locked {\n    .box {\n      background: none;\n    }\n  }\n}\n\n.scoreboard {\n  .text {\n    color: var(--color-primary-blue);\n    font-weight: 600;\n    font-size: 0.9rem;\n\n    &.score {\n      font-size: 1rem;\n    }\n  }\n\n  .bold-text {\n    color: var(--color-white);\n    font-weight: 800;\n    font-size: 1.121rem;\n\n    &.score {\n      font-size: 1.569rem;\n    }\n  }\n\n  .score-row {\n    border-radius: 8px;\n    background: rgba(0, 51, 153, .16);\n    margin-bottom: 0.333rem;;\n  }\n\n  .score-col {\n    padding-top: 0.533rem;\n    padding-bottom: 0.533rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n\n    & .date {\n      white-space: nowrap;\n    }\n\n    &.badges {\n      padding-right: 1rem;\n      display: flex;\n\n      .icon {\n        position: relative;\n        width: 1.333rem;\n        height: 1.333rem;\n        &:not(:last-child) {\n          margin-right: 0.333rem;\n        }\n\n        .bg {\n          width: auto;\n          height: 100%;\n        }\n\n        .image {\n          position: absolute;\n          top: 0;\n          left: 0;\n          display: flex;\n          width: 100%;\n          height: auto;\n        }\n      }\n    }\n    &.score {\n      background: rgba(0, 51, 153, .2);\n      display: flex;\n      border-top-right-radius: 8px;\n      border-bottom-right-radius: 8px;\n    }\n    &.country {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n\n      div:first-child {\n        margin-bottom: -0.25rem;\n      }\n\n      .flag {\n        height: 1.333rem;\n        width: 1.333rem;\n        box-shadow: 0 0.083rem 0 0 rgba(0,0,0,0.24);\n        border-radius: 1.333rem;\n        margin-right: 1rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
